/* Quantity stepper + Ajax add-to-cart, shared by shop grid cards and the PDP. */
document.addEventListener('click', function (e) {
  var dec = e.target.closest('[data-qty-dec]');
  var inc = e.target.closest('[data-qty-inc]');
  if (dec || inc) {
    var stepper = (dec || inc).closest('[data-qty-stepper]');
    var valEl = stepper.querySelector('[data-qty-value]');
    var val = parseInt(valEl.textContent, 10) || 1;
    val = dec ? Math.max(1, val - 1) : Math.min(20, val + 1);
    valEl.textContent = val;
    return;
  }

  var addBtn = e.target.closest('[data-add-to-cart]');
  if (addBtn) {
    var card = addBtn.closest('[data-product-card]');
    var variantId = addBtn.getAttribute('data-variant-id');
    var qtyEl = card ? card.querySelector('[data-qty-value]') : null;
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
    var sellingPlanId = addBtn.getAttribute('data-selling-plan-id') || null;

    addBtn.classList.add('is-loading');
    var originalText = addBtn.textContent;
    window.ChaiCart.add(variantId, qty, sellingPlanId)
      .then(function () {
        addBtn.textContent = 'Added';
        var addedNote = card ? card.querySelector('[data-added-note]') : null;
        if (addedNote) addedNote.hidden = false;
        setTimeout(function () {
          addBtn.textContent = originalText;
          addBtn.classList.remove('is-loading');
          if (addedNote) addedNote.hidden = true;
        }, 1800);
        if (qtyEl) qtyEl.textContent = '1';
      })
      .catch(function () {
        addBtn.textContent = 'Try again';
        addBtn.classList.remove('is-loading');
        setTimeout(function () { addBtn.textContent = originalText; }, 1800);
      });
  }
});
